<template>
  <div class="page-container">
    <Breadcrumb routeName="IntegralOrderList" toName="订单详情" goPathName="订单列表"></Breadcrumb>
    <a-card :bordered="false" style="margin-bottom:15px;">
      <a-row>
        <a-col :span="17">
          <detail-list :col="1" class="order-big">
            <detail-list-item term="订单编号">{{ orderBasicInfo.orderNo }}</detail-list-item>
          </detail-list>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="7">
          <detail-list :col="1">
            <detail-list-item term="来源用户">{{ orderBasicInfo.userName }}</detail-list-item>
            <detail-list-item term="下单时间">{{ orderBasicInfo.createDate }}</detail-list-item>
            <detail-list-item term="支付日期" v-if="orderBasicInfo.payDate">{{ orderBasicInfo.payDate }}
            </detail-list-item>
            <detail-list-item term="支付方式" v-if="orderBasicInfo.payTypeStr">
              {{ orderBasicInfo.payTypeStr }}({{ orderBasicInfo.orderPoints }})
            </detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="10">
          <detail-list :col="1">
            <detail-list-item term="兑换商品">{{ orderBasicInfo.productName }}</detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="7">
          <a-row class="status-list">
            <a-col :xs="12" :sm="12">
              <div class="text">状态</div>
              <div class="heading">{{ orderBasicInfo.orderStatusStr }}</div>
            </a-col>
            <a-col :xs="12" :sm="12">
              <div class="text">订单金额</div>
              <div class="heading">¥ {{ orderBasicInfo.orderAmount }}</div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'IntegralOrderDetail',
  components: {
    Breadcrumb
  },
  data() {
    return {
      orderId: 0,
      orderBasicInfo: {}
    }
  },
  mounted() {
    this.orderId = this.getPageParams().orderId
    this.getOrderDetails()
  },
  methods: {
    //获取用户详情信息
    getOrderDetails() {
      const params = { orderId: this.orderId }
      this.getHttpServices().getIntegralApiService().post('admin/pointsOrder/getBackPointsOrderDetail', params).then(detail => {
        this.getLogUtils().logWithTag('订单详情', detail)
        this.orderBasicInfo = detail
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style scoped lang="less">

</style>